import { render, staticRenderFns } from "./related-problems.vue?vue&type=template&id=3afc49f7&"
import script from "./related-problems.vue?vue&type=script&lang=js&"
export * from "./related-problems.vue?vue&type=script&lang=js&"
import style0 from "./related-problems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports